export default function preventBrowserBack() {
  setWindowHistory()
  window.addEventListener('popstate', setWindowHistory)
}

function setWindowHistory() {
  window.history.pushState(null, '', window.location.pathname)
}
